import React from 'react'
import styled from 'styled-components'
import PathCard from './PathCard'

interface props {
  handleSelectProgram: Function
}

export default function PAVsCTL({ handleSelectProgram }: props) {
  return (
    <Container>
      <Header>Where Would You Like to Start?</Header>
      <SubHeader>Let’s find the right path for your health goals.</SubHeader>
      <SubHeader>Choose the option that best fits what you’re looking to do:</SubHeader>
      <CardCont>
        <PathCard
          header="I’m Ready to Make Sure My Medications Are Working for Me"
          bestFor="People managing ongoing health conditions or taking multiple medications"
          details={[
            'Have a pharmacist review your medications',
            'Review your prescriptions, over-the-counter meds, and supplements',
            'Talk about your lifestyle and health goals',
            'Discover ways to save money on prescriptions',
            'Get free tools like a blood pressure cuff or a diabetes meter + testing supplies',
          ]}
          handleSelectProgram={handleSelectProgram}
          ctl={false}
        />
        <PathCard
          header="I’m Ready to Focus on My Weight and Overall Health"
          bestFor="People looking to lose weight, lower their BMI, and build healthy habits."
          details={[
            'Work with a personal health coach',
            'Get a plan that fits your life and goals',
            'Receive a welcome kit with a cellular scale, water bottle, tape measure, and portion plate',
            'Access medication support if needed',
            'Track your meals and progress in the Tria Health app',
          ]}
          handleSelectProgram={handleSelectProgram}
          ctl={true}
        />
      </CardCont>
    </Container>
  )
}

const Container = styled.div`
  font-family: Raleway;
  text-align: center;
  max-width: 1200px;
  margin: auto;
  padding: 60px 10px;
  justify-content: center;

  @media only screen and (max-width: 600px) {
    padding: 30px 20px;
  }
`
const Header = styled.h1`
  font-weight: 700;
  font-size: 40px;
  margin-bottom: 30px;
`

const SubHeader = styled.h2`
  font-weight: 600;
  font-size: 20px;
  margin-left: auto;
  margin-right: auto;
`

const CardCont = styled.div`
  display: flex;
  justify-content: space-around;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 40px;
  @media only screen and (max-width: 600px) {
    flex-direction: column;
    margin-top: 0px;
  }
`
